<template>
    <b-modal id="configureProfileModal" :title="$t('configureProfile.title')" ok-only @ok="reloadProductTree()">

        <b-container>
            <b-row style="padding-bottom: 20px">
                <b-col cols="4" class="my-auto" style="font-weight: bold">
                    {{ $t('configureProfile.username') }}
                </b-col>
                <b-col cols="6" class="float-left">
                    {{ username }}
                </b-col>
            </b-row>
            <b-row style="padding-bottom: 20px">
                <b-col cols="4" class="my-auto" style="font-weight: bold">
                    {{ $t('configureProfile.email') }}
                </b-col>
                <b-col cols="6" class="float-left">
                    <b-form-input :placeholder="email" :disabled="true"/>
                </b-col>
            </b-row>
            <b-row v-if="!extern">
                <b-col cols="4" class="my-auto" style="font-weight: bold">
                    {{ $t('configureProfile.mode') }}
                </b-col>
                <b-col cols="6" class="float-left">
                    <b-form-checkbox v-model="expertenModus" :disabled="!einstellungenAendernErlaubt" switch>
                        <div v-if="expertenModus">
                            {{ $t('configureProfile.enabled') }}
                        </div>
                        <div v-else>
                            {{ $t('configureProfile.disabled') }}
                        </div>
                    </b-form-checkbox>
                </b-col>
            </b-row>
        </b-container>


    </b-modal>
</template>

<script>
    import i18n from "@/i18n/i18n";

    export default {
        name: "ConfigureProfilModal",
        methods: {
          reloadProductTree() {
            this.$store.dispatch('initProductTree', i18n.locale)
          }
        },
        computed: {
            username: function() {
                return this.$store.getters.getUserData.displayName;
            },

            email: function() {
                return this.$store.getters.getUserData.eMailAdresse;
            },

            einstellungenAendernErlaubt: function() {
                return this.$store.getters.getUserData.einstellungenAendernErlaubt;
            },

            extern: function() {
                return this.$store.getters.getUserData.extern;
            },

            expertenModus: {
                get() {
                    return this.$store.getters.isUserExpertenModus;
                },
                set(value) {
                    this.$store.dispatch('setUserDefaultMode', value);
                }
            }
        }
    }
</script>

<style scoped>

</style>